export const classes = {
  icon: 'text-grey-6 dark:text-mauve-3 text-xl cursor-pointer',
};
